import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { logError } from '$lib/helpers/errors';

/**
 * Poll a payments/{paymentIntentId} doc until it’s either
 *   { status: "completed", orderId }  OR  { status: "refunded" }
 *
 * @param {string} pid   Stripe PaymentIntent ID
 * @param {number} [timeoutMs=20000]
 * @returns {Promise<{ ok:boolean, orderId?:string }>} ok==false → refunded
 */
// default wait time increased to give the webhook more time to
// finish writing the payment document on slower deployments
export async function waitForPayment(pid, timeoutMs = 30_000) {
	const db = getFirestore();
	const ref = doc(db, 'payments', pid);
	console.log(`[waitForPayment] start polling ${pid} for ${timeoutMs}ms`);

	const started = Date.now();
	while (Date.now() - started < timeoutMs) {
		const snap = await getDoc(ref);
		if (!snap.exists()) {
			console.log('[waitForPayment] no payment doc yet');
		}
		if (snap.exists()) {
			const data = snap.data();
			console.log('[waitForPayment] status check', data);

			if (data.status === 'completed' && data.orderId) {
				console.log('[waitForPayment] completed', data.orderId);

				return { ok: true, orderId: data.orderId };
			}

			if (data.status === 'refunded') return { ok: false };
		}
		await new Promise((r) => setTimeout(r, 1000));
	}
	console.log('[waitForPayment] timed out');
	const err = new Error('Payment document not updated before timeout');
	logError(err, 'waitForPayment:timeout', { pid, timeoutMs });
	return { ok: false, timeout: true }; // timed-out → treat as failure
}
